module.exports = __webpack_public_path__ + "img/warning.9af69239.svg";